(function () {
  const FEE_VARIANT_ID = 44669937549382; // Decoration Fee ($1) variant
  const originalFetch = window.fetch;

  // -------- helpers ----------
  const toInt = (v) => {
    const n = parseInt(String(v || "").replace(/[^0-9]/g, ""), 10);
    return Number.isFinite(n) ? n : 0;
  };

  const isCartMutationUrl = (url) => {
    const u = String(url || "");
    return (
      u.includes("/cart/add") ||
      u.includes("/cart/add.js") ||
      u.includes("/cart/change") ||
      u.includes("/cart/change.js") ||
      u.includes("/cart/update") ||
      u.includes("/cart/update.js") ||
      u.includes("/cart/clear") ||
      u.includes("/cart/clear.js")
    );
  };

  // -------- reconcile (delete orphan fees) ----------
  let reconciling = false;
  let debounceTimer = null;

  async function reconcileFeesOnce() {
    if (reconciling) return;
    reconciling = true;

    try {
      const cartRes = await originalFetch("/cart.js", { method: "GET" });
      const cart = await cartRes.json();

      // build set of apparel variant IDs still in cart (excluding fee product)
      const apparelVariantIds = new Set(
        (cart.items || [])
          .filter((i) => Number(i.id) !== Number(FEE_VARIANT_ID))
          .map((i) => String(i.id))
      );

      // SAFETY: if we temporarily read a cart state that contains ONLY fee items,
// do NOT delete everything. This can happen during drawer/cart transitions.
// We'll let the later retries handle cleanup safely.
const hasAnyFeeLines = (cart.items || []).some((i) => {
  if (Number(i.id) !== Number(FEE_VARIANT_ID)) return false;
  const p = i.properties || {};
  return p._is_decoration_fee === "1";
});

if (apparelVariantIds.size === 0 && hasAnyFeeLines) {
  return; // bail out; don't mass-delete
}

      // delete any fee line we created that points to a missing apparel variant
      for (const item of cart.items || []) {
        if (Number(item.id) !== Number(FEE_VARIANT_ID)) continue;

        const p = item.properties || {};
        if (p._is_decoration_fee !== "1") continue; // only manage our fee lines

        const feeForVariant = String(p._fee_for_variant || "");
        if (!feeForVariant) continue;

        if (!apparelVariantIds.has(feeForVariant)) {
          await originalFetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        }
      }
    } catch (e) {
      console.warn("reconcileFeesOnce failed:", e);
    } finally {
      reconciling = false;
    }
  }

  // Run reconcile with debounce + retries (handles cart-page form reload timing)
  function scheduleReconcile() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      reconcileFeesOnce();
      setTimeout(reconcileFeesOnce, 800);
      setTimeout(reconcileFeesOnce, 2000);
    }, 200);
  }

  // -------- fee injection on product add ----------
  let injecting = false;

  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const method = (init && init.method) || (input && input.method) || "GET";
    const upper = String(method).toUpperCase();

    // Intercept Spotlight add-to-cart
    if (!injecting && upper === "POST" && String(url).includes("/cart/add")) {
      const body = init && init.body;

      if (body instanceof FormData) {
        const variantId = body.get("id");
        const qty = toInt(body.get("quantity")) || 1;

        const customTotalRaw = body.get("properties[Customization Total]");
        const perUnitCustom = toInt(customTotalRaw);
        const feeQty = perUnitCustom * qty;

        // Only add fee when customization exists
        if (variantId && feeQty > 0) {
          injecting = true;

          // 1) Let Spotlight add the main product normally (fast UI)
          const spotlightRes = await originalFetch(input, init);

          // 2) Add fee in background (do not await)
          Promise.resolve()
            .then(() =>
              originalFetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  items: [
                    {
                      id: Number(FEE_VARIANT_ID),
                      quantity: Number(feeQty),
                      properties: {
                        _is_decoration_fee: "1",
                        _fee_lock: "1",
                        _fee_for_variant: String(variantId),
                      },
                    },
                  ],
                }),
              })
            )
            .then(() => scheduleReconcile())
            .catch((e) => console.warn("Fee add failed:", e))
            .finally(() => {
              injecting = false;
            });

          return spotlightRes;
        }
      }
    }

    // normal fetch
    const res = await originalFetch.apply(this, arguments);

    // After any cart mutation (drawer/cart page AJAX), reconcile
    if (!injecting && upper === "POST" && isCartMutationUrl(url)) {
      scheduleReconcile();
    }

    return res;
  };

  // -------- XHR hook (cart page themes sometimes use XHR) ----------
  (function interceptXHR() {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__m = String(method || "GET").toUpperCase();
      this.__u = String(url || "");
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      try {
        this.addEventListener("loadend", () => {
          if (!injecting && this.__m === "POST" && isCartMutationUrl(this.__u)) {
            scheduleReconcile();
          }
        });
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  })();

  // -------- run cleanup on every page load (cart page delete = page reload) ----------
  document.addEventListener("DOMContentLoaded", () => {
    scheduleReconcile();
  });
})();